// TODO: standard bytewise encoding constructor
// TODO: enhance binary encoding with optional hex helpers
module.exports = require('./binary')


//////////////////
// WEBPACK FOOTER
// ./node_modules/bytewise/encoding/index.js
// module id = XL2b
// module chunks = 70